(() => {
  const guardName = '__andskyCartTrustEmptyEnhancements';
  if (window[guardName]) return;
  window[guardName] = true;

  const config = {
    showShippingTrust: true,
    showCommunityLink: true,
    groupUrl: 'https://www.facebook.com/groups/andskyebike',
    saleUrl: '/collections/ebike',
    accessoriesUrl: '/collections/accessories',
    bestSellerUrl: '/collections/ebike?sort_by=best-selling',
  };

  const ensureStyle = () => {
    if (document.getElementById('and-cart-trust-empty-style')) return;

    const style = document.createElement('style');
    style.id = 'and-cart-trust-empty-style';
    style.textContent = `
      #CartDrawer .and-cart-footer > .and-cart-local-trust,
      #CartDrawer .and-cart-footer > .and-cart-community-link { display: none !important; }
      #CartDrawer .and-cart-scroll-trust-stack { display: grid; gap: 8px; margin: 10px 0 12px; }
      #CartDrawer .and-cart-scroll-trust-stack[hidden] { display: none !important; }
      #CartDrawer .and-cart-scroll-local-trust,
      #CartDrawer .and-cart-scroll-community { display: flex; align-items: center; gap: 10px; padding: 10px 11px; border-radius: 6px; text-align: left; }
      #CartDrawer .and-cart-scroll-local-trust { border: 1px solid #cfe6d8; background: #f3fbf6; color: #183b2a; }
      #CartDrawer .and-cart-scroll-community { justify-content: space-between; border: 1px solid #d5e1f5; background: #f5f8ff; color: #18345f; }
      #CartDrawer .and-cart-scroll-icon { flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center; width: 20px; height: 20px; border-radius: 999px; background: #1f8a4c; color: #fff; font-size: 12px; font-weight: 700; line-height: 1; }
      #CartDrawer .and-cart-scroll-copy { min-width: 0; flex: 1 1 auto; font-size: 12px; line-height: 1.35; }
      #CartDrawer .and-cart-scroll-copy strong,
      #CartDrawer .and-cart-scroll-copy span { display: block; }
      #CartDrawer .and-cart-scroll-copy strong { color: inherit; font-size: 13px; font-weight: 700; }
      #CartDrawer .and-cart-scroll-copy span { margin-top: 2px; color: inherit; opacity: 0.86; }
      #CartDrawer .and-cart-scroll-community__btn { flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center; min-height: 32px; padding: 8px 11px; border-radius: 5px; background: #1d6eea; color: #fff !important; font-size: 12px; font-weight: 700; line-height: 1; text-decoration: none !important; white-space: nowrap; }
      #CartDrawer .and-cart-empty { display: flex; flex-direction: column; justify-content: flex-start; min-height: calc(100vh - 88px); padding: 44px 28px 28px !important; background: linear-gradient(180deg, #ffffff 0%, #ffffff 38%, #f6f7f9 100%) !important; text-align: center; }
      #CartDrawer .and-cart-empty > p:first-child { margin: 0; color: #111; font-size: 16px; line-height: 1.35; }
      #CartDrawer .and-cart-empty > div:not(.and-cart-empty-actions) { margin-top: 6px; color: #111; font-size: 15px; font-weight: 700; line-height: 1.35; }
      #CartDrawer .and-cart-empty-actions { display: grid; gap: 14px; width: 100%; max-width: 390px; margin: 28px auto 0; }
      #CartDrawer .and-cart-empty-actions__title { margin: 0; color: #111; font-size: 22px; font-weight: 800; line-height: 1.15; letter-spacing: 0; }
      #CartDrawer .and-cart-empty-actions__subtitle { margin: -6px 0 2px; color: #565656; font-size: 13px; line-height: 1.4; }
      #CartDrawer .and-cart-empty-actions__grid { display: grid; grid-template-columns: 1fr; gap: 10px; }
      #CartDrawer .and-cart-empty-link { display: flex; align-items: center; justify-content: space-between; gap: 12px; min-height: 54px; padding: 12px 14px; border: 1px solid #e4e4e4; border-radius: 8px; background: #fff; color: #111 !important; text-align: left; text-decoration: none !important; box-shadow: 0 6px 18px rgba(0, 0, 0, 0.04); }
      #CartDrawer .and-cart-empty-link strong,
      #CartDrawer .and-cart-empty-link span { display: block; }
      #CartDrawer .and-cart-empty-link strong { font-size: 14px; font-weight: 800; line-height: 1.2; }
      #CartDrawer .and-cart-empty-link span { margin-top: 3px; color: #666; font-size: 12px; line-height: 1.25; }
      #CartDrawer .and-cart-empty-link::after { content: '›'; flex: 0 0 auto; color: #ff5a1f; font-size: 24px; line-height: 1; font-weight: 400; }
      #CartDrawer .and-cart-empty-link--primary { border-color: #ff5a1f; background: #ff5a1f; color: #fff !important; }
      #CartDrawer .and-cart-empty-link--primary span,
      #CartDrawer .and-cart-empty-link--primary::after { color: #fff; opacity: 0.9; }
      #CartDrawer .and-cart-empty-community { display: grid; gap: 8px; margin-top: 2px; padding: 14px; border: 1px solid #d5e1f5; border-radius: 8px; background: #f5f8ff; color: #18345f; text-align: left; }
      #CartDrawer .and-cart-empty-community strong { display: block; font-size: 13px; line-height: 1.25; }
      #CartDrawer .and-cart-empty-community span { display: block; color: #335072; font-size: 12px; line-height: 1.35; }
      #CartDrawer .and-cart-empty-community a { display: inline-flex; align-items: center; justify-content: center; min-height: 36px; padding: 9px 12px; border-radius: 6px; background: #1d6eea; color: #fff !important; font-size: 13px; font-weight: 800; line-height: 1; text-decoration: none !important; }
      @media (max-width: 480px) { #CartDrawer .and-cart-empty { padding: 38px 22px 24px !important; } #CartDrawer .and-cart-empty-actions__title { font-size: 20px; } }
    `;
    document.head.appendChild(style);
  };

  const createTrustStack = () => {
    const stack = document.createElement('div');
    stack.className = 'and-cart-scroll-trust-stack';
    stack.setAttribute('role', 'note');

    if (config.showShippingTrust) {
      const shipping = document.createElement('div');
      shipping.className = 'and-cart-scroll-local-trust';
      shipping.innerHTML = '<span class="and-cart-scroll-icon" aria-hidden="true">✓</span><span class="and-cart-scroll-copy"><strong>Ships from local warehouse where available</strong><span>Free shipping · Secure checkout · Warranty support</span></span>';
      stack.appendChild(shipping);
    }

    if (config.showCommunityLink) {
      const community = document.createElement('div');
      community.className = 'and-cart-scroll-community';
      community.innerHTML = '<span class="and-cart-scroll-copy"><strong>Still deciding?</strong><span>Join our Facebook rider community.</span></span><a class="and-cart-scroll-community__btn" href="' + config.groupUrl + '" target="_blank" rel="noopener">Join Group</a>';
      stack.appendChild(community);
    }

    if (!stack.children.length) stack.hidden = true;
    return stack;
  };

  const ensureScrollTrust = () => {
    const drawer = document.querySelector('#CartDrawer');
    const scrollArea = drawer?.querySelector('.and-cart-scroll');
    if (!drawer || !scrollArea) return;

    let stack = scrollArea.querySelector('.and-cart-scroll-trust-stack');
    if (!stack) {
      stack = createTrustStack();
      const note = scrollArea.querySelector('.and-cart-note');
      const assurance = scrollArea.querySelector('.and-cart-assurance');
      if (note) scrollArea.insertBefore(stack, note);
      else if (assurance?.nextSibling) scrollArea.insertBefore(stack, assurance.nextSibling);
      else scrollArea.appendChild(stack);
    }
  };

  const findEmptyCart = () => {
    const drawer = document.querySelector('#CartDrawer');
    if (!drawer) return null;
    const direct = drawer.querySelector('.and-cart-empty');
    if (direct) return direct;
    return Array.from(drawer.querySelectorAll('div, section')).find((node) => {
      const text = (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      return text.includes('cart is currently empty') || text.includes('your cart is empty');
    }) || null;
  };

  const ensureEmptyCartActions = () => {
    const emptyCart = findEmptyCart();
    if (!emptyCart || emptyCart.querySelector('.and-cart-empty-actions')) return;

    const actions = document.createElement('div');
    actions.className = 'and-cart-empty-actions';
    actions.innerHTML = '<h3 class="and-cart-empty-actions__title">Start with a ride</h3><p class="and-cart-empty-actions__subtitle">Pick an e-bike, add accessories, or ask real owners before checkout.</p><div class="and-cart-empty-actions__grid"><a class="and-cart-empty-link and-cart-empty-link--primary" href="' + config.saleUrl + '"><span><strong>Shop All E-Bikes</strong><span>Explore our full range of e-bikes</span></span></a><a class="and-cart-empty-link" href="' + config.bestSellerUrl + '"><span><strong>Best-selling e-bikes</strong><span>See what riders choose most</span></span></a><a class="and-cart-empty-link" href="' + config.accessoriesUrl + '"><span><strong>Accessories</strong><span>Racks, trailers, parts and add-ons</span></span></a></div><div class="and-cart-empty-community"><div><strong>Still comparing models?</strong><span>Join the Andsky rider community on Facebook for owner photos, tips and real questions.</span></div><a href="' + config.groupUrl + '" target="_blank" rel="noopener">Join Facebook Group</a></div>';
    emptyCart.appendChild(actions);
  };

  const apply = () => {
    ensureStyle();
    ensureScrollTrust();
    ensureEmptyCartActions();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();

  let tries = 0;
  const retryTimer = window.setInterval(() => {
    apply();
    tries += 1;
    if (tries >= 24) window.clearInterval(retryTimer);
  }, 500);

  document.addEventListener('cart:refresh', apply);
  document.addEventListener('cart:updated', apply);
  document.addEventListener('shopify:section:load', apply);
  new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });
})();
